export default __webpack_public_path__ + "static/media/male-img.979b4c6b.png";